import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { useCompanyStore } from '@/stores/company'

/* Note: this mixin deliberately has no setup(). Vue 3 reads `setup` off the
   component's own options object, so a setup() declared in a mixin is silently
   ignored. Pages needing a vee-validate form context must call useForm() in
   their own setup() - see Login.vue and RegisterPage.vue. */
export default {
  computed: {
    ...mapStores(useAuthStore, useCompanyStore),
    whiteLabel () {
      return this.companyStore.whiteLabel
    },
    baseRouteConfig () {
      return this.companyStore.baseRouteConfig
    }
  },

  methods: {
    /* Logs in with the credentials as-is. Callers are responsible for validating
       first - Login.vue via submitLogin, RegisterPage after its own submit. */
    loginCallBack () {
      this.authStore
        .getToken(this.user)
        .then(data => {
          if (!data.verify_login) {
            this.handleUnverifiedLogin(data.access_token)
            return
          }

          /* The token goes through the store, not route params - Vue Router 4
             strips params the '2fa' path has no segment for. */
          this.authStore.setPendingToken(data.access_token)

          this.$router.push({
            ...this.baseRouteConfig,
            name: '2fa',
            replace: true
          })
        })
        .catch(error => console.error('Login failed:', error))
    },
    handleUnverifiedLogin (accessToken) {
      this.authStore
        .login({ accessToken })
        .then(investors => {
          this.handleLoginRedirection(investors)
        })
        .catch(error => console.error('Login failed:', error))
    },
    handleVerifiedLogin (accessToken, secret) {
      this.authStore
        .handle2FA({ accessToken, secret })
        .then(investors => {
          this.handleLoginRedirection(investors)
        })
        .catch(error => console.error('Two-factor verification failed:', error))
    },
    handleLoginRedirection (investors) {
      const whiteLabel = this.whiteLabel

      if (whiteLabel.fromWhiteLabeledDomain) {
        this.savedUrl
          ? this.$router.push({ ...this.baseRouteConfig, path: this.savedUrl, replace: true })
          : this.$router.push({ ...this.baseRouteConfig, name: 'dashboard', replace: true })
      } else {
        investors.length > 1
          ? this.$router.push({
              ...this.baseRouteConfig,
              name: 'select-company',
              params: { savedUrl: this.savedUrl },
              replace: true
            })
          : this.savedUrl
          ? this.$router.push({ ...this.baseRouteConfig, path: this.savedUrl, replace: true })
          : this.$router.push({ ...this.baseRouteConfig, name: 'dashboard', replace: true })
      }
    }
  }
}
